
import { defineComponent } from "vue";
import LButtom from "../LButtom/LButtom.vue";
import { mapMutations, mapState } from "vuex";
import { removeLocalStorage } from "@/helpers/setLocalStore";
import LButtomMenu from "@/components/LButtom/LButtomMenu.vue";

export default defineComponent({
  name: "LNavbar",
  data() {
    return { this_route: true, menuToggle: false };
  },
  computed: {
    ...mapState(["switchLogin", "isLogin", "token", "user"]),
  },
  components: { LButtom, LButtomMenu },
  methods: {
    ...mapMutations([
      "toggleSwitchLogin",
      "updateSateFromStorage",
      "clearVuex",
    ]),

    register() {
      this.toggleSwitchLogin();
    },
    close() {
      //Elimnar local storage
      removeLocalStorage();
      //eliminar Vuex
      //this.updateSateFromStorage();
      this.clearVuex();
      // redirigir a root /
      this.$router.push("/");
    },

    showMenu() {
      this.menuToggle = !this.menuToggle;
      const menu = document.getElementById("navbar__menu");
      menu?.classList.toggle("show");
    },
  },
  watch: {
    $route(to) {
      if (to.href === "/") {
        this.this_route = true;
      } else if (to.href !== "/") {
        this.this_route = false;
      }
    },
  },
});
